import { useEffect, useState } from "react";

import { getLeaveResetValue } from "@api/leave-balance";

export const useLeaveBalanceReset = () => {
  const [data, setData] = useState<any>(false);

  const handleLeaveBalanceReset = (updatedData: boolean) =>
    setData(updatedData);

  useEffect(() => {
    getLeaveResetValue()
      .then((data) => setData(data.data.showButton))
      .catch((err) => console.log(err));

    return setData(false);
  }, []);

  return { showButton: data, handleLeaveBalanceReset };
};
